import React from 'react';
import {connect} from 'react-redux';
import TeamLogo from 'components/molecules/team-logo';
import {LineupPlayers as BaseLineupPlayers} from 'components/organisms/lineup/components/lineup-players';
import PlayerInjury from 'components/molecules/player-injury';

class LineupPlayersComponent extends BaseLineupPlayers {
    render() {
        const {lineups, lineupId} = this.props;
        const lineup = lineups.getLineup(lineupId);

        if (!lineup) {
            return null;
        }

        const rows = lineup.players.map((player) => {
            return (
                <tr key={player.playerId} className={this.getRowClassName(player)}>
                    <td>
                        <strong>{player.name}</strong>
                        <PlayerInjury player={player} />
                    </td>
                    <td>{player.positionInLineup}</td>
                    <td>
                        <TeamLogo teamName={player.team.toUpperCase()} />
                    </td>
                    <td>
                        <strong className="text-gray">{player.getPropValueOfLineupRole('salary')}</strong>/
                        {this.getPlayerPointsView(player)}
                    </td>
                </tr>
            );
        });

        return (
            <table className="table">
                <tbody>{rows}</tbody>
            </table>
        );
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {games},
        lineupsData: {lineups},
        filterLineupsByPlayer,
        sportConfig,
    } = state;

    return {
        games,
        lineups,
        filterLineupsByPlayer,
        sportConfig,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
